import { mdiArrowLeftRight } from '@mdi/js';
import { TableTitle } from 'common/components/tables';
import { useProducerWithThunks } from 'common/hooks/useProducer';
import { xactAccountRecipe } from 'common/state/banking/recipes';
import { defaultXactAccountState } from 'common/state/banking/states';
import { doGetXactAccount } from 'common/state/banking/thunkActions';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';

interface AccountParams {
  accountCode: string;
}

const InfoTable = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 0.5rem;
  font-size: 0.875rem;
  margin: 0 1rem 2rem;
  width: fit-content;
`;

export const AccountInfo = () => {
  const { accountCode } = useParams<AccountParams>();
  const [xactAccountState, xactAccountDispatch] = useProducerWithThunks(
    xactAccountRecipe,
    defaultXactAccountState
  );

  useEffect(() => {
    xactAccountDispatch(doGetXactAccount(accountCode));
  }, [xactAccountDispatch, accountCode]);

  const { account } = xactAccountState;

  return (
    <>
      <TableTitle
        icon={mdiArrowLeftRight}
        title={`Movements for: ${
          xactAccountState.pending
            ? 'Loading...'
            : account?.name || 'Account not found'
        }`}
      />
      <InfoTable>
        <span>Account Code:</span>
        <span>
          {xactAccountState.pending
            ? 'Loading...'
            : account?.full_code || accountCode}
        </span>
        <span>Currency:</span>
        <span>
          {xactAccountState.pending
            ? 'Loading...'
            : account?.currency || 'Uknown'}
        </span>
      </InfoTable>
    </>
  );
};
